import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";

export const saveWebInfo = async (params: stdObject) => {
  const {
    t,
    modalData,
    customUpdate,
    windowValues,
    openErrorMsg,
    startLoading,
    closeMsg,
    logoutAction,
  } = params;
  const fieldInfo = Object.entries(windowValues.web).reduce(
    (acc: stdObject, curr: [string, any]) =>
      curr[1] ? { ...acc, [curr[0]]: curr[1] } : acc,
    {},
  );
  if (windowValues.main.ACTTAB === 1 && Object.keys(fieldInfo).length === 0) {
    openErrorMsg(
      {
        code: "warning",
        title: t("p.someFieldActivated"),
      },
      1,
    );
  } else {
    startLoading();
    const payloadSaveWebInfo: stdObject = {
      type: modalData.type,
      table: modalData.table,
      info: Object.entries(windowValues.main).reduce(
        (acc: stdObject, curr: [string, any]) => {
          return {
            ...acc,
            [curr[0]]: typeof curr[1] === "string" ? curr[1].trim() : curr[1],
          };
        },
        {},
      ),
      fields: fieldInfo,
    };

    console.log("payloadSaveWebInfo: ", payloadSaveWebInfo);
    const resultSaveWebInfo: stdObject = await sendData({
      endPoint: "saveWebInfo",
      payload: payloadSaveWebInfo,
      logoutAction,
    });
    console.log("resultSaveWebInfo", resultSaveWebInfo);
    if (resultSaveWebInfo.success && resultSaveWebInfo.status) {
      customUpdate.current = {
        webInfo: modalData.index,
        info: { ...resultSaveWebInfo.info[0] },
      };
    }
    closeMsg();
  }
};
